export default {"src":"/_next/static/media/atalon-logo.765abda0.svg","height":32,"width":32};